import styled, { css } from 'styled-components';

import { theme } from '@notino/react-styleguide';

export const Wrapper = styled.div<{ newPdDesignEnabled: boolean }>`
  padding: 0 0 1rem 0;
  ${({ newPdDesignEnabled }) =>
    newPdDesignEnabled
      ? theme.typography.labelRegular400
      : css`
          font-size: 0.875rem;
        `}
`;

export const StyledAddToWishlist = styled.a`
  display: flex;
  user-select: none;
  cursor: pointer;
  text-decoration: none !important;
  align-items: center;

  &:hover {
    text-decoration: underline !important;
    svg {
      color: ${theme.color.icon.highlight} !important;
    }
  }
`;
